<table id="invoice" mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="imageUrl">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell [ngClass]="{'no-border': i === products.length - 1}" *matCellDef="let element let i = index">
      <img height="30" width="30" loading="lazy" *ngIf="element.imageUrl" [src]="imageBaseUrl + element.imageUrl" />
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Produs</th>
    <td mat-cell [ngClass]="{'no-border': i === products.length - 1}" *matCellDef="let element let i = index">
      <a *ngIf="element.type !== 'simple-accessory'" [routerLink]="this.getRouteUrl(element)">
      <span class="product">{{element.name}}</span>
      </a>
      <span *ngIf="element.type === 'simple-accessory'" class="product">{{element.name}}</span>
    </td>

  </ng-container>
  <ng-container matColumnDef="producer">
    <th mat-header-cell *matHeaderCellDef> Brand</th>
    <td mat-cell [ngClass]="{'no-border': i === products.length - 1}" *matCellDef="let element let i = index"><span
      class="product">{{element.producer}}</span></td>
  </ng-container>

  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef> Preț</th>
    <td mat-cell [ngClass]="{'no-border': i === products.length - 1}" *matCellDef="let element let i = index">
      <span *ngIf="element.type !== 'simple-accessory'">de la </span>
      <span class="product">{{element.price | roncurrency}}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
